import { createContext, useContext, useEffect, useState } from "react";

const DeviceContext = createContext();

const getDeviceType = (width) => {
  if (width < 768) return "mobile";
  if (width < 1024) return "tablet";
  return "desktop";
};

export function DeviceProvider({ children }) {
  const [device, setDevice] = useState(
    typeof window !== "undefined" ? getDeviceType(window.innerWidth) : "desktop"
  );

  useEffect(() => {
    const handleResize = () => {
      setDevice(getDeviceType(window.innerWidth));
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <DeviceContext.Provider value={{ device }}>
      {children}
    </DeviceContext.Provider>
  );
}

export function useDevice() {
  return useContext(DeviceContext);
}
